module.exports = __webpack_public_path__ + "img/Transform20.dbe3e9a3.png";